module.exports = __webpack_public_path__ + "static/media/clausulaAjuste.36fe884f.svg";